export const appConfig = {
    API_ENDPOINT: 'https://o50hrzv5d5.execute-api.us-east-1.amazonaws.com/prod',
    TIMEOUT: 20000
}